import React from "react";
import { ToastContainer } from "react-toastify";
import { ReactComponent as Close } from "../../../../assets/icons/ToastCancel.svg";
import useModals from "../../../../hooks/useModals";

const ModalRenderer: React.FC = () => {
  const { getModals } = useModals();
  return (
    <>
      {getModals().map((value: any, index: number) => (
        <div key={index}>{value}</div>
      ))}
      <ToastContainer
        position="top-center"
        autoClose={2000}
        style={{
          position: "fixed",

          maxHeight: "56px",
          minHeight: "56px",
        }}
        hideProgressBar
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        closeButton={CloseButton}
      />
    </>
  );
};

export default ModalRenderer;
const CloseButton = ({ closeToast }: any) => (
  <i style={{ height: "16px" }} className="material-icons" onClick={closeToast}>
    <Close />
  </i>
);
